<template>
  <el-container>
    <el-aside></el-aside>
    <el-container direction="vertical">
      <el-header>
        <div class="tools">
          <i @click.prevent="collapse" class="fa fa-align-justify"></i> 资源下载及商务采购平台
        </div>
      </el-header>
      <el-main>Main</el-main>
    </el-container>
  </el-container>

</template>

<script>
  import slider from "./CommmericalSlider.vue"
  import Main from "./CommericalMain.vue"

  import trans from '../../transform/trans'

  export default {
    name: 'app',
    data: function () {
      return {
        collapsed: false
      }
    },
    components: {
      "el-aside": slider,
      "el-main": Main
    }, methods: {
      collapse: function () {
        this.collapsed = !this.collapsed;
        trans.$emit('collapse-slider', this.collapsed)
      }
    }
  }
</script>
<style>
  .el-header {
    background-color: #001f3f;
    color: #fff;
    text-align: left;
    line-height: 60px;
    font-size: 1.5em;
  }

  .el-container {
    height: 100%;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/commerical/CommercialContainer.vue